<!-- ErrorPopup.svelte -->
<script lang="ts">
  import { errorStore } from '../../main';
  import { onDestroy } from 'svelte';
  import ContactUs from './contact-us.svelte';

  let showError = false;

  const unsubscribe = errorStore.subscribe((error) => {
    // Only show contact form for critical errors, not minor JS errors
    if (
      error &&
      error.message &&
      (error.message.toString().includes('Critical') ||
        error.message.toString().includes('Fatal') ||
        error.message.toString().includes('Network') ||
        error.message.toString().includes('API') ||
        error.message.toString().includes('Server'))
    ) {
      showError = true;
    }
  });

  onDestroy(() => {
    unsubscribe();
  });

  let showThankyouMessage = false;
</script>

{#if showError && !showThankyouMessage}
  <ContactUs
    on:submit={() => {
      window.location.href = '/step/1';
    }}
  />
{/if}
